import { Panel, Readout } from '@tiw/ui';
import { useSelectionStore } from '@/stores/useSelectionStore';

/**
 * Selection panel — bottom-left HUD readout for the currently-selected PoP.
 *
 * Hidden when nothing is selected. Selection is committed by clicking a PoP
 * marker on the globe (see GlobeScene + useSelectionStore).
 */
export function SelectionPanel(): JSX.Element | null {
  const selected = useSelectionStore((s) => s.selected);
  if (!selected) return null;

  return (
    <Panel
      title="SELECTION"
      style={{
        position: 'absolute',
        bottom: 56,
        left: 24,
        width: 248,
        pointerEvents: 'auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          fontFamily: 'JetBrains Mono, ui-monospace, monospace',
        }}
      >
        <div style={{ fontSize: 13, letterSpacing: '0.04em' }}>{selected.name}</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 18px' }}>
          <Readout label="REGION" value={selected.regionCode} />
          <Readout label="CAPACITY" value={(selected.capacityGbps / 1000).toFixed(1)} unit="Tbps" />
          <Readout
            label="STATUS"
            value={selected.online ? 'ONLINE' : 'OFFLINE'}
            tone={selected.online ? 'good' : 'warn'}
          />
          <Readout label="ID" value={selected.id} />
        </div>
      </div>
    </Panel>
  );
}
